import React from 'react';
import Helmet from 'react-helmet';
import { BreadCrumbs } from '../components/BreadCrumbs';
import { Text } from '../components/Text';
import { SupportPublicationsListSection } from '../components/SupportPublicationsListSection';
import { headings } from '../data';

const SupportPublicationsListRoute = () => (
  <>
    <Helmet title='Инструкции и руководства по установке для принтеров этикеток, принтеров чеков' />
    <BreadCrumbs crumbs={[['/support'], ['/publications']]} />
    <Text type='h1'>{headings['/publications']}</Text>
    <SupportPublicationsListSection />
  </>
);

export default SupportPublicationsListRoute;
